import {createClient} from '@sanity/client';
import * as Environment from '../../env';

export const sanityClient = createClient({
  projectId: Environment.sanityProjectId(),
  dataset: Environment.sanityDataset(),
  apiVersion: Environment.sanityApiVersion(),
  useCdn: true,
});
